import React from "react";
import InputField from "../reusableComponents/InputField";
import SubmitButton from "../reusableComponents/SubmitButton";
import { Link } from "react-router-dom";

class Reset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: "",
      username: "",
      newPassword: "",
      confirmPassword: "",
      loading: false,
      tokenValidated: false,
      incorrectDetails: false,
    };
  }
  setInputValue(property, val) {
    val = val.trim();

    this.setState({
      [property]: val,
    });
  }
  handleKeyDownToken(e) {
    if (e.key === "Enter") {
      this.doTokenValidate();
    }
  }
  handleKeyDownPassword(e) {
    if (e.key === "Enter") {
      this.doPasswordUpdate();
    }
  }

  async doPasswordUpdate() {
    this.setState({
      loading: true,
    });

    if (
      !this.state.tokenValidated ||
      !this.state.newPassword ||
      !this.state.confirmPassword ||
      this.state.newPassword !== this.state.confirmPassword ||
      this.state.newPassword.length < 8 ||
      !new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})").test(
        this.state.newPassword
      )
    ) {
      this.setState({
        incorrectDetails: true,
        confirmPassword: "",
        newPassword: "",
      });
      console.log("does not meet criteria");
    } else {
      try {
        let res = await fetch("/updatePassWithToken", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token: this.state.token,
            newPassword: this.state.newPassword,
            confirmPassword: this.state.confirmPassword,
          }),
        });
        let result = await res.json();

        if (result && result.success) {
          console.log("Success Now Pushing:");
          alert(
            "Password Reset Successfully, Please login with the new password"
          );
          this.props.history.push("/login");
          this.setState({
            incorrectDetails: false,
            token: "",
            tokenValidated: false,
          });
        } else if (result && result.success === false) {
          this.setState({
            incorrectDetails: true,
            newPassword: "",
            confirmPassword: "",
          });

          alert(result.msg);
          if (
            result.msg.includes(
              "This token does not exist or is no longer valid."
            )
          ) {
            this.props.history.push("/reset");
          }
        }
      } catch (e) {
        console.log(e);
        this.setState({
          incorrectDetails: true,
          newPassword: "",
          confirmPassword: "",
        });
      }
    }
    this.setState({
      loading: false,
    });
  }

  async doTokenValidate() {
    this.setState({
      loading: true,
    });

    if (!this.state.token) {
      this.setState({
        incorrectDetails: true,
        tokenValidated: false,
      });
    } else {
      try {
        let res = await fetch("/validatetoken", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token: this.state.token,
          }),
        });
        let result = await res.json();

        if (result && result.success) {
          this.setState({
            incorrectDetails: false,
            tokenValidated: true,
            token: result.token,
            username: result.username,
          });
        } else if (result && result.success === false) {
          this.setState({
            incorrectDetails: true,
            tokenValidated: false,
            token: "",
          });

          alert(result.msg);
          this.props.history.push("/reset");
        }
      } catch (e) {
        console.log(e);
        this.setState({
          incorrectDetails: true,
          tokenValidated: false,
          token: "",
        });
      }
    }
    this.setState({
      loading: false,
    });
  }

  render() {
    if (
      !this.state.loading &&
      !this.state.tokenValidated &&
      this.props.match.params.token &&
      this.props.match.params.token !== ""
    ) {
      this.setState({ token: this.props.match.params.token });
      this.doTokenValidate();
      return (
        <div className="app">
          <div className="container">Loading, please wait...</div>
        </div>
      );
    } else if (this.state.loading) {
      return (
        <div className="app">
          <div className="container">Loading, please wait...</div>
        </div>
      );
    } else if (this.state.tokenValidated) {
      return (
        <div className="app">
          <div className="container">
            Username: {this.state.username}
            <div className="instructions">
              Please enter the new password and confirm the password in the
              boxes below.
              <br />
              The password must contain the following:
              <br />
              -At least 8 characters <br />
              -At least 1 upper-case letter <br />
              -At least 1 lower-case letter <br />
              -At least 1 number <br />
            </div>
            <div className="errorText">
              {this.state.incorrectDetails
                ? "Please make sure your password follows the above criteria, and is the same in both boxes"
                : ""}
            </div>
            <InputField
              type="password"
              placeholder="New Password"
              value={this.state.newPassword ? this.state.newPassword : ""}
              onChange={(val) => this.setInputValue("newPassword", val)}
              onKeyDown={() => {}}
            />
            <InputField
              type="password"
              placeholder="Confirm Password"
              value={
                this.state.confirmPassword ? this.state.confirmPassword : ""
              }
              onChange={(val) => this.setInputValue("confirmPassword", val)}
              onKeyDown={(e) => this.handleKeyDownPassword(e)}
            />
            <SubmitButton
              text="Update Password"
              disabled={false}
              onClick={() => {
                this.doPasswordUpdate();
              }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="app">
          <div className="container">
            <div className="resettedForm">
              Finish Password Reset
              <div className="instructions">
                Please open your email and follow the link to finish resetting
                your password.
                <br /> <br />
                Optionally you can paste your token below
              </div>
              <div className="errorText">
                {this.state.incorrectDetails
                  ? "This is not a valid token or has expired."
                  : ""}
              </div>
              <InputField
                type="text"
                placeholder="Token"
                value={this.state.token ? this.state.token : ""}
                onChange={(val) => this.setInputValue("token", val)}
                onKeyDown={(e) => this.handleKeyDownToken(e)}
              />
              <SubmitButton
                text="Validate Token"
                disabled={false}
                onClick={() => {
                  this.doTokenValidate();
                }}
              />
              <Link to="/forgot">
                <div className="hyper-link">Resend token email</div>
              </Link>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Reset;
